import type { JSX } from '@builder.io/qwik';
import { Slot } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { ButtonGroupBlockInterface } from '~/types/AppData/PageBuilder/ButtonGroupBlockInterface';
import { cva } from 'class-variance-authority';

const buttonClasses = cva('flex flex-wrap items-center gap-4', {
  variants: {
    align: {
      left: 'justify-start',
      center: 'justify-center',
      right: 'justify-end',
    },
  },
});

export default component$<ButtonGroupBlockInterface['props']>(
  ({ align }): JSX.Element => {
    return (
      <div class={buttonClasses({ align })}>
        <Slot />
      </div>
    );
  }
);
